/**
 * Textos y destinos de las pantallas de error de la app (404, 403 y 500). Los usa components/PaginaError.jsx.
 * Las pantallas NO muestran datos técnicos ni la dirección pedida: solo el código, un título y un mensaje que se entienda.
 */

export const TIPOS_ERROR = {
  // 401: a esta pantalla lleva (302 desde el servidor) abrir en el navegador la dirección de un archivo subido SIN sesión válida.
  // Es la misma para cualquier archivo, exista o no, y no muestra ni lleva el nombre. El botón va siempre al login.
  401: {
    codigo: '401',
    titulo: 'Archivo protegido',
    mensaje: 'Este archivo solo se puede ver con la sesión iniciada. Ingresá al sistema y volvé a intentar.',
    boton: 'Ir al inicio de sesión',
    accion: 'login',
  },
  404: {
    codigo: '404',
    titulo: 'Página no encontrada',
    mensaje: 'La dirección que buscás no existe o fue movida. Revisá que esté bien escrita o volvé al inicio.',
    boton: 'Volver al inicio',
    accion: 'inicio',
  },
  403: {
    codigo: '403',
    titulo: 'Sin acceso',
    mensaje: 'Tu usuario no tiene permiso para ver esta sección. Si creés que es un error, consultá con el administrador de tu municipio.',
    boton: 'Volver al inicio',
    accion: 'inicio',
  },
  500: {
    codigo: '500',
    titulo: 'Algo salió mal de nuestro lado',
    mensaje: 'Tuvimos un problema inesperado. Probá de nuevo en unos minutos; si sigue, avisale al administrador de tu municipio.',
    boton: 'Reintentar',
    accion: 'reintentar',
  },
};

/**
 * A dónde lleva "Volver al inicio": al panel de Superadmin si se está en su dominio (panel.<dominio>), al dashboard si hay
 * sesión de municipio, y al login si no. Es un link común (recarga la app), así también anda cuando la pantalla de error
 * aparece por una falla de la propia app.
 */
export function destinoInicio({ hostname = window.location.hostname, token = null } = {}) {
  if (String(hostname).toLowerCase().startsWith('panel.')) return '/superadmin';
  return token ? '/dashboard' : '/login';
}

export function haySesion() {
  try {
    return !!sessionStorage.getItem('token');
  } catch (e) {
    return false;
  }
}
